import PropTypes from 'prop-types';
import React from 'react';
import { Link } from '../utils/router/v3Bridge';
import PostShape from '../propTypes/PostShape';
import { publicPostPath } from '../utils/url/postPath';
import styles from './PublicTopicPosts.module.scss';

const propTypes = {
  posts: PropTypes.arrayOf(PostShape).isRequired,
};

const PublicTopicPosts = ({ posts }) => (
  <div className={styles.container}>
    {posts.map((post) => (
      <Link key={post.id} to={publicPostPath(post)}>
        {post.title}
      </Link>
    ))}
  </div>
);

PublicTopicPosts.propTypes = propTypes;

export default PublicTopicPosts;
